import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { CartAndLineItemGroups } from '@/types/commercetools';
import { activePromoCodeAtom, promoConfigAtom } from '@/atoms/promoAtom';
import { useCart } from './useCartHooks';
const filterLineItemGroups = (cartAndLineItemGroups: CartAndLineItemGroups, productTypeIds: string[]) => {
  return cartAndLineItemGroups.lineItemGroups.filter(group => group.productTypeId && productTypeIds.includes(String(group.productTypeId)));
};
export const useDiscountedPrice = (price, productTypeId) => {
  const $ = _c(9);
  const promoConfig = useAtomValue(promoConfigAtom);
  const activePromoCode = useAtomValue(activePromoCodeAtom);
  const {
    data: cartAndLineItemGroups
  } = useCart();
  let t0;
  bb0: {
    if (!productTypeId || !promoConfig || !promoConfig.content["promo-tool"].elements.strikethroughPrices || !activePromoCode || activePromoCode.code !== promoConfig.content["promo-tool"].campaignDetails.code) {
      t0 = null;
      break bb0;
    }
    const t1 = promoConfig.content["promo-tool"];
    let t2;
    if ($[0] !== cartAndLineItemGroups || $[1] !== price || $[2] !== productTypeId || $[3] !== t1.promoConditions) {
      let t3;
      if ($[5] !== cartAndLineItemGroups || $[6] !== price || $[7] !== productTypeId) {
        t3 = condition => {
          if (condition.restrictions.productTypes && !condition.restrictions.productTypes.includes(productTypeId)) {
            return false;
          }
          if (condition.restrictions.minOrderItems) {
            const basketItemCount = !cartAndLineItemGroups ? 0 : condition.restrictions.restrictByCategoryOrProductTypes ? filterLineItemGroups(cartAndLineItemGroups, condition.restrictions.productTypes || []).reduce(_temp2, 0) : cartAndLineItemGroups.cart.totalLineItemQuantity;
            if (basketItemCount + 1 < condition.restrictions.minOrderItems) {
              return false;
            }
          }
          if (condition.restrictions.minOrderValue) {
            const basketValue = !cartAndLineItemGroups ? 0 : condition.restrictions.restrictByCategoryOrProductTypes ? filterLineItemGroups(cartAndLineItemGroups, condition.restrictions.productTypes || []).reduce(_temp3, 0) : cartAndLineItemGroups.lineItemGroups.reduce(_temp4, 0);
            if (basketValue / 100 + price < condition.restrictions.minOrderValue) {
              return false;
            }
          }
          return true;
        };
        $[5] = cartAndLineItemGroups;
        $[6] = price;
        $[7] = productTypeId;
        $[8] = t3;
      } else {
        t3 = $[8];
      }
      t2 = t1.promoConditions.filter(_temp).find(t3);
      $[0] = cartAndLineItemGroups;
      $[1] = price;
      $[2] = productTypeId;
      $[3] = t1.promoConditions;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t0 = t2;
  }
  const matchingCondition = t0;
  if (matchingCondition) {
    return price - price * (matchingCondition.value / 100);
  }
  return price;
};
function _temp(c) {
  return c.type === "PercentageBased";
}
function _temp2(sum, group) {
  return sum + group.groupQuantity;
}
function _temp3(sum_0, group_0) {
  return sum_0 + group_0.groupTotalCentAmount;
}
function _temp4(sum_1, group_1) {
  return sum_1 + group_1.groupTotalCentAmount;
}